import { TextAlignment } from "shared/datamodel/schemas/text-enabled-schema";
import { TextAlignLeft, TextAlignCenter } from "frontend/icons/icons";
import style from "./textAlignmentPicker.module.css";
import ToggleButton from "./toggle-button";
import { ButtonRow } from "./toolbar-design-system";

export default function TextAlignmentPicker({
  value,
  onChange,
  multi,
}: {
  value: TextAlignment;
  onChange: (newAlign: TextAlignment) => void;
  multi?: boolean;
}) {
  return (
    <div className={style.container} data-testid="TextAlignmentPicker">
      <ButtonRow>
        <ToggleButton isOn={value === "left" && !multi} onClick={() => onChange("left")} data-testid="textalignleft">
          <TextAlignLeft />
        </ToggleButton>

        <ToggleButton
          isOn={value === "center" && !multi}
          onClick={() => onChange("center")}
          data-testid="textaligncenter"
        >
          <TextAlignCenter />
        </ToggleButton>

        <ToggleButton isOn={value === "right" && !multi} onClick={() => onChange("right")} data-testid="textalignright">
          <TextAlignLeft mirrored />
        </ToggleButton>
      </ButtonRow>
    </div>
  );
}
